import { ReactElement } from 'react'
import { SectionContainer } from '../containers/section-container'
import { Link } from '@app/components/stateless/typo/link'
import { Header3, Header4 } from '@app/components/general/header'
import {
  GrCloudComputer,
  GrCloudSoftware,
  GrDesktop,
  GrTestDesktop,
} from 'react-icons/gr'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import Trans from 'next-translate/Trans'

const infoDetails = [
  {
    href: '/cloud',
    Icon: GrCloudSoftware,
    beta: false,
  },
  {
    href: '/why-us',
    Icon: GrCloudComputer,
    beta: false,
  },
  {
    href: '/vscode-extension',
    Icon: GrTestDesktop,
    beta: false,
  },
  {
    href: '/desktop',
    Icon: GrDesktop,
    beta: true,
  },
]

export function MarketingProducts(): ReactElement<any, any> | null {
  const { t } = useTranslation('website-accessibility-checker')

  return (
    <SectionContainer gapY={'small'}>
      <div className='py-4 pb-12'>
        <div className='flex space-x-2 place-items-center'>
          <Header3>{t('tools-header')}</Header3>
        </div>
        <p className='pb-4 text-gray-700 dark:text-gray-200'>
          {t('tools-details')}
        </p>

        <ul
          className={
            'text-left gap-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
          }
        >
          {infoDetails.map(({ href, Icon, beta }, i: number) => {
            return (
              <li key={i} className={'grid'}>
                <Link
                  className={
                    'border-2 border-gray-600 dark:border-gray-400 rounded-sm p-4 space-y-2 hover:no-underline hover:border-blue-600 dark:hover:border-blue-600 hover:text-blue-600'
                  }
                  href={href}
                >
                  {beta ? (
                    <span className='flex place-items-center space-x-2'>
                      <Header4 className='text-left'>
                        {t(`tools.${i}.header`)}
                      </Header4>
                      {beta ? (
                        <span className='text-yellow-700 text-sm rounded border border-yellow-600 px-2'>
                          {t('beta')}
                        </span>
                      ) : null}
                    </span>
                  ) : (
                    <Header4 className='text-left'>
                      {t(`tools.${i}.header`)}
                    </Header4>
                  )}
                  <div className={'text-base'}>
                    <Trans
                      i18nKey={`website-accessibility-checker:tools.${i}.details`}
                      components={[<p key={'h-1'} />]}
                    />
                  </div>
                  <span className='flex flex-1 h-20 rounded-sm place-items-center place-content-center text-medium md:text-xl lg:text-2xl'>
                    <Icon className='grIcon' />
                  </span>
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </SectionContainer>
  )
}
